(() => {
  const menu = document.querySelector('[data-tmall-mobile-menu]');
  const nav = document.getElementById('nav');

  if (!menu || !nav) return;

  menu.hidden = false;
  document.documentElement.classList.add('tmall-mobile-menu-ready');

  const tabs = [...menu.querySelectorAll('[data-tmall-menu-tab]')];
  const panels = [...menu.querySelectorAll('[data-tmall-menu-panel]')];
  const categoryLinks = [...menu.querySelectorAll('[data-tmall-category-link]')];
  const submenu = menu.querySelector('[data-tmall-mobile-submenu]');
  const submenuOpeners = [...menu.querySelectorAll('[data-tmall-submenu-open]')];
  const submenuBack = menu.querySelector('[data-tmall-submenu-back]');
  const mainHeader = menu.querySelector(':scope > .tmall-mobile-menu__header');
  const mainBody = menu.querySelector(':scope > .tmall-mobile-menu__body');
  let activeSubmenuTrigger = null;
  let submenuTimer = 0;

  const setMainLayerHidden = (hidden) => {
    menu.classList.toggle('has-submenu', hidden);
    [mainHeader, mainBody].forEach((layer) => {
      if (!(layer instanceof HTMLElement)) return;
      layer.inert = hidden;
      if (hidden) layer.setAttribute('aria-hidden', 'true');
      else layer.removeAttribute('aria-hidden');
    });
  };

  const closeSubmenu = (restoreFocus = true) => {
    if (!(submenu instanceof HTMLElement) || submenu.hidden) return;

    window.clearTimeout(submenuTimer);
    submenu.classList.remove('is-open');
    submenu.setAttribute('aria-hidden', 'true');
    activeSubmenuTrigger?.setAttribute('aria-expanded', 'false');
    const trigger = activeSubmenuTrigger;

    submenuTimer = window.setTimeout(() => {
      if (!submenu.classList.contains('is-open')) {
        submenu.hidden = true;
        setMainLayerHidden(false);
      }
      if (restoreFocus && trigger instanceof HTMLElement) trigger.focus();
    }, 220);
  };

  const openSubmenu = (trigger) => {
    if (!(submenu instanceof HTMLElement)) return;

    window.clearTimeout(submenuTimer);
    activeSubmenuTrigger = trigger;
    setMainLayerHidden(true);
    submenu.hidden = false;
    submenu.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    submenu.getBoundingClientRect();
    submenu.classList.add('is-open');
    window.requestAnimationFrame(() => submenuBack?.focus());
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      closeSubmenu(false);
      tabs.forEach((item) => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.tmallMenuPanel !== tab.dataset.tmallMenuTab;
      });

      categoryLinks.forEach((link) => {
        link.hidden = link.dataset.tmallCategoryLink !== tab.dataset.tmallMenuTab;
      });
    });
  });

  submenuOpeners.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openSubmenu(trigger);
    });
  });

  submenuBack?.addEventListener('click', (event) => {
    event.preventDefault();
    event.stopPropagation();
    closeSubmenu();
  });

  menu.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && submenu instanceof HTMLElement && !submenu.hidden) {
      event.preventDefault();
      event.stopPropagation();
      closeSubmenu();
    }
  });

  menu.querySelectorAll('[data-tmall-mobile-menu-close]').forEach((closeButton) => {
    closeButton.addEventListener('click', () => {
      closeSubmenu(false);
      const trigger = document.querySelector('[aria-controls="nav"][aria-expanded="true"]');
      if (trigger instanceof HTMLElement) trigger.click();
    });
  });
})();
